export default __webpack_public_path__ + "static/media/ISO-Certificate-9001-2015.94ccfb95.png";